import request from '@utils/request'
import configRequest from "@src/config/request";

export const state = {}

export const mutations = {}

export const actions = {
  /*
   * 取得選單
   * */
  /**
   *
   * @param commit
   * @param params [brand, solution_category, industry_category, product_parent_category, product_child_category,
   *   download_file_category, contract_file_category]
   * @returns {Promise<AxiosResponse<any>>}
   */
  fetchCategroy({ commit }, params) {
    return request
      .post(`/option/list`, params, {
        ...configRequest,
        name: 'fetchCategroy'
      })
      .then((response) => response.items)
  },
};
